// extracted by mini-css-extract-plugin
export var textInput = "_i1-0";